import React from 'react';
import { Button } from '../Button';
import Icons from '../../Icons/Icons';
import { cn } from '../../../../utils/styles';

interface IPagination {
  current: number;
  total: number;
  handlePageChange: (page: number) => void;
}

function Pagination({ current, total, handlePageChange }: IPagination) {
  return (
    <div className="grid gap-[5px] grid-cols-[auto,auto] text-muted-foreground items-center justify-start">
      <span className="text-sm text-muted-foreground">{`${current}-${total} of ${total}`}</span>
      <div className="grid grid-cols-[34px,auto,34px] justify-start items-center">
        <Button
          variant="ghost"
          className={cn('p-[5px] h-[34px]', {
            'opacity-30 pointer-events-none': current === 1,
          })}
          onClick={() => handlePageChange(current - 1)}
        >
          <Icons.ArrowRight className="transform -scale-x-100" />
        </Button>
        <div className="w-[20px] text-center font-medium text-sm">{current}</div>
        <Button
          variant="ghost"
          className={cn('p-[5px] h-[34px]', {
            'opacity-30 pointer-events-none': current === total,
          })}
          onClick={() => handlePageChange(current + 1)}
        >
          <Icons.ArrowRight />
        </Button>
      </div>
    </div>
  );
}

export default Pagination;
